import * as React from "react";
import { useEffect, useState } from "react";
import {v4 as uuidv4} from "uuid";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import colorConfigs from "src/configs/colorConfigs";
import { RouteType } from "src/routes/config";
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import SidebarItem from "./SidebarItem";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import sizeConfigs from "src/configs/sizeConfigs";

type Props = {
  item: RouteType;
};

/**
 * @function SidebarItemCollapse
 * @description Renderiza un elemnto de menú colapsable.
 * @param {RouteType} item: Elemento menu a renderizar.
 * @returns {React.JSX.Element | null}
 */
const SidebarItemCollapse = ({ item }: Props): React.JSX.Element | null => {
  const [open, setOpen] = useState(false);

  const { appState } = useSelector((state: RootState) => state.appState);

  useEffect(() => {
    if (appState.includes(item.state)) {
      setOpen(true);
    }
  }, [appState, item]);

  const setOpenClose = (event: React.MouseEvent<HTMLElement>) => {
    if(event?.stopPropagation) event.stopPropagation();
    setOpen(!open)
  }

  return (
    item.sidebarProps ? (
      <>
        <ListItemButton
          key={uuidv4()}
          onClick={setOpenClose}
          sx={{
            "&: hover": {
              backgroundColor: colorConfigs.sidebar.hover.bg,
              color: colorConfigs.sidebar.hover.color,
            },
            color: colorConfigs.sidebar.color,
            paddingY: sizeConfigs.sidebar.item.marginY,
            paddingX: sizeConfigs.sidebar.item.marginX,
          }}
        >
          <ListItemIcon
            key={uuidv4()}
            sx={{
              color: colorConfigs.sidebar.color,
            }}
          >
            {item.sidebarProps.icon && item.sidebarProps.icon}
          </ListItemIcon>
          <ListItemText
            key={uuidv4()}
            disableTypography
            primary={
              <Typography fontWeight={700}>
                {item.sidebarProps.displayText}
              </Typography>
            }
          />
          {open ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          key={uuidv4()}
          in={open}
          timeout="auto"
          sx={{
            marginX: sizeConfigs.sidebar.itemCollapse.marginX,
            border: colorConfigs.sidebar.pannelCollapse.border,
            borderColor: colorConfigs.sidebar.pannelCollapse.borderColor,
            paddingY: "0px",
            marginY: "0px",
          }}
        >
          <List
            key={uuidv4()}
            sx={{
              paddingX: sizeConfigs.sidebar.itemCollapse.paddingX,
              paddingY: "0px",
              marginY: "0px",
            }}
          >
            {item.child?.map((route) => (
              route.sidebarProps ? (
                route.child ? (
                  <SidebarItemCollapse item={route} key={uuidv4()} />
                ) : (
                  <SidebarItem item={route} key={uuidv4()} isChild />
                )
              ) : null
            ))}
          </List>
        </Collapse>
      </>
    ) : null
  );
};

export default SidebarItemCollapse;
